var m = require('mithril');
var d3 = require('d3');
var heading = require('../../components/heading');
var c3 = require('../../libs/chart');
var edit = require('../../layout/components/edit');
var builderEditView = require('../../libs/builderEditView');
var Point = require('../../data/models/point');
var pointSubscriber = require('../../components/pointSubscriberClass');
var helpModal = require('../../help/helpModal');

var gaugeChart = {};

gaugeChart.oninit = function (vnode) {
  var ctrl = this;
  ctrl.element = vnode.attrs.element;
  ctrl.parentReinitialize = vnode.attrs.parentReinitialize;
  ctrl.dashboardCallback = vnode.attrs.dashboardCallback;
  ctrl.options = {data:{}};
  ctrl.dataset = ctrl.element.out_Contains[0].in;
  ctrl.point = ctrl.element.out_Contains[0].in.out_Column && ctrl.element.out_Contains[0].in.out_Column.length > 0 ? ctrl.element.out_Contains[0].in.out_Column[0].in : [];

  if(ctrl.point['@rid']){
    var columnRecord = ctrl.element.out_Contains[0].in.out_Column[0];
    var value = Point.readValue(ctrl.point);
    
    ctrl.options = {
      //bindto: element,
      data: {
        columns: [['data', value]],
        type: 'gauge'
      },
      legend: {
        hide: true
      },
      gauge: {
        label: {
          show: true,
          format: function (value, ratio) {
            return d3.format(',.3f')(value);
          }
        },
        expand: false,
        width: 10,
        max: columnRecord.max || 100,
        min: columnRecord.min || 0,
        units: Point.formatUnit(columnRecord.in)
      },
      color: {
          pattern: ['#00E98F']
      },
      axis:{},
      size: {
        height: 200,
      }
    }
  }
};

gaugeChart.oncreate = function () {
  if (this.point['@rid']) {
    this.pointSubscriberObj = new pointSubscriber();
    this.pointSubscriberObj.subscribe({column: this.element.out_Contains[0].in.out_Column[0]});
  }
}

gaugeChart.onremove = function () {
  if (this.point['@rid']) {
    this.pointSubscriberObj.unsubscribe({column: this.element.out_Contains[0].in.out_Column[0]});
  }
}


gaugeChart.view = function(vnode) {
  var ctrl = this;
  ctrl.options.data.columns = [['data', Point.readValue(ctrl.point)]]

  return m('div', {style: {minHeight: '10em'}}, [
    m(heading, {
      label: ctrl.element.name, 
      class: 'f1', 
      element: ctrl.element, 
      parentReinitialize: ctrl.parentReinitialize, 
      dashboardCallback: ctrl.dashboardCallback,
      datasetRepresentation: vnode.attrs.datasetRepresentation
    }, [
      ctrl.element.helpText ?
        m('i.ion-ios-information-outline.white.f1.ml2', {
          onclick: () => {
            helpModal.editDialogue(ctrl.element.name, undefined, ctrl.element.helpText);
          }
        })
      :
        ''
    ]),
    edit.vm.editing() ? 
      m(builderEditView, {element: ctrl.element, parentReinitialize: ctrl.parentReinitialize})
    :  
      ctrl.point['@rid'] ?
        m('div', [
          m(c3,{
            options: ctrl.options,
            oncreate: function (vnode) {
              ctrl.chart = vnode.state.chart;
              vnode.attrs = ctrl.options
            }
          }),
        ])
      : 
        (()=>{
          if (!edit.vm.editing() && vnode.attrs.datasetRepresentation) {
            return m('table.w-100', {style: {tableLayout: 'fixed'}}, [
              m('tbody', [
                (ctrl.dataset.columns || []).map(function (column, jdx) {
                  return m('tr.bb', [
                    m('td.f3.man.bb.tl.moon-gray.w-50.truncate',  column.name),
                    m('td.f3.man.bb.tl.moon-gray.w-50', '') 
                  ])
                })
              ])
            ])
          }
        })()
    
  ])
};


module.exports = gaugeChart;
